import { ReactNode } from 'react';
import { useAuth } from '@/contexts/auth';
import { hasPermission, PermissionAction } from '@/utils/permissions';

interface PermissionGuardProps {
  children: ReactNode;
  action: PermissionAction;
  fallback?: ReactNode;
}

export const PermissionGuard = ({ children, action, fallback = null }: PermissionGuardProps) => {
  const { user } = useAuth();
  
  if (!hasPermission(user, action)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
